module.exports = __webpack_public_path__ + "img/4.ef6faf48.jpg";